import { Examination_Type } from "@generated/graphql";
import TextFieldControl from "components/form/TextFieldControl";
import TestingLink from "components/TestingLink";
import useIsCreate from "hooks/useIsCreate";
import { UseFormGetValues, UseFormReturn } from "react-hook-form";
import CompetencyMapControl from "../../components/CompetencyMapControl";
import { CompetencyMapOptionList } from "../../types";
import { GroupAndOpenInfoInputs } from "../types";

interface GroupAndOpenRightProps {
  form: UseFormReturn<GroupAndOpenInfoInputs>;
  examinationType: Examination_Type | undefined;
  competencyMaps: CompetencyMapOptionList;
  competencyMapsLoading: boolean;
}

const GroupAndOpenRight = ({
  form,
  examinationType,
  competencyMaps,
  competencyMapsLoading,
}: GroupAndOpenRightProps) => {
  const isCreate = useIsCreate();
  const getValues = form.getValues as unknown as UseFormGetValues<GroupAndOpenInfoInputs>;

  const showTestingLink = examinationType === Examination_Type.Open || examinationType === Examination_Type.Public;

  return (
    <>
      <CompetencyMapControl
        competencyMaps={competencyMaps}
        isEditing={isCreate}
        competencyMapsLoading={competencyMapsLoading}
        type='examination'
      />
      <TextFieldControl
        name='competencyMapComment'
        label='Комментарий к карте компетенций'
        minRows={7}
        multiline
        disabled
      />
      <TextFieldControl
        name='competencyMapGrades'
        label='Грейд карты компетенций'
        disabled
      />
      {showTestingLink && <TestingLink link={getValues("link")} />}
      {/* пока оставил, вдруг понадобится */}
      {/* {examinationType === Examination_Type.Group && (
        <Stack spacing={0.5}>
          <FieldLabel label='Загрузить кандидатов' />
          <FileUploadButton
            name='candidatesFile'
            label='Загрузить кандидатов'
            accept='.xlsx'
          />
        </Stack>
      )} */}
    </>
  );
};

export default GroupAndOpenRight;
